import api from "./api";
import UnitName, { UnitNameDTO } from "@/model/unitName";

interface UnitNameListResponseInterface {
  meta: string;
  data: UnitNameDTO[];
}
class UnitNameApi extends api {
  constructor() {
    super();
    this.setup();
  }
  async index(): Promise<UnitName[]> {
    const response = await this.getHttp().get<UnitNameListResponseInterface>(
      "/units"
    );

    if (response.data.data) {
      return response.data.data.map((item) => {
        return new UnitName(item);
      });
    }
    return [];
  }

  
}
export default new UnitNameApi();
